import { useMutation } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { InviteUserToOrganizationDto } from '@dealstack/shared/lib/generated';

const inviteOrganizationUser = async ({
	organizationId,
	email,
	firstName,
	lastName,
	permissionRoles,
	options,
}: { organizationId: string } & InviteUserToOrganizationDto) => {
	return await makeRequest({
		endpoint: formatUnicorn(API_PATHS.ORGANIZATION_ORGANIZATIONID_USERS_POST, {
			organizationId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify({
			email,
			firstName,
			lastName,
			permissionRoles,
			options,
		}),
	});
};

export const useInviteOrganizationUser = () => {
	return useMutation({
		mutationFn: inviteOrganizationUser,
	});
};
